import { Form } from "react-bootstrap";
import { neturalBlack, netural400 } from "../../constants/color";

/**
 * Duplicate-slice toggle row shared by Create and Detail pages.
 */
const DuplicateToggle = ({ checked, onChange, disabled = false }) => (
  <div
    style={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: "12px 16px",
      backgroundColor: "#F9F9F9",
      borderRadius: "10px",
      marginBottom: "16px",
      opacity: disabled ? 0.5 : 1,
      pointerEvents: disabled ? "none" : "auto",
    }}
  >
    <div>
      <label
        style={{
          fontSize: "14px",
          fontWeight: "600",
          color: neturalBlack,
          display: "block",
        }}
      >
        Duplicate slice setup?
      </label>
      <label style={{ fontSize: "12px", color: netural400 }}>
        Repeat your selected products across all slices.
      </label>
    </div>
    <Form.Check
      type="switch"
      checked={checked}
      onChange={onChange}
      disabled={disabled}
      style={{ transform: "scale(1.3)" }}
    />
  </div>
);

export default DuplicateToggle;
